<template>
    <div>
      <div v-if="showModal" class="overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none justify-center items-center flex">
        <div class="relative w-auto my-6 mx-auto max-w-3xl">
          <!--content-->
          <div class="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
            <!--header-->
            <div class="flex items-start justify-between p-5 border-b border-solid border-blueGray-200 rounded-t">
              <h3 class="text-3xl font-semibold">
                Detail API
              </h3>
              <button class="p-1 ml-auto bg-transparent border-0 text-black opacity-5 float-right text-3xl leading-none font-semibold outline-none focus:outline-none" v-on:click="toggleModal()">
                <span class="bg-transparent text-black opacity-5 h-6 w-6 text-2xl block outline-none focus:outline-none">
                  ×
                </span>
              </button>
            </div>
            <!--body-->
            <div class="relative p-6 flex-auto">
              <div class="flex-auto px-0 lg:px-0 py-0 pt-0">
                <div class="flex flex-wrap">
                  <div class="w-full lg:w-6/12 px-4">
                    <div class="relative w-full pr-4 max-w-full flex-grow flex-1">
                      <h5 class="text-blueGray-400 uppercase font-bold text-xs">Client Name</h5>
                      <span class="font-semibold text-xl text-blueGray-700">{{ client['client_name'] }}</span>
                    </div>
                  </div>
                  <div class="w-full lg:w-6/12 px-4">
                    <div class="relative w-full pr-4 max-w-full flex-grow flex-1">
                      <h5 class="text-blueGray-400 uppercase font-bold text-xs">App Name</h5>
                      <span class="font-semibold text-xl text-blueGray-700">{{ client['app_name'] }}</span>
                    </div>
                  </div>
                  <div class="w-full lg:w-6/12 px-4">
                    <div class="relative w-full pr-4 max-w-full flex-grow flex-1">
                      <h5 class="text-blueGray-400 uppercase font-bold text-xs">Version</h5>
                      <span class="font-semibold text-xl text-blueGray-700">{{ client['version'] }}</span>
                    </div>
                  </div>
                  <div class="w-full lg:w-6/12 px-4">
                    <div class="relative w-full pr-4 max-w-full flex-grow flex-1">
                      <h5 class="text-blueGray-400 uppercase font-bold text-xs">Intention</h5>
                      <span class="font-semibold text-xl text-blueGray-700">{{ client['intention'] }}</span>
                    </div>
                  </div>
                  <div class="w-full lg:w-6/12 px-4">
                    <div class="relative w-full pr-4 max-w-full flex-grow flex-1">
                      <h5 class="text-blueGray-400 uppercase font-bold text-xs">Method</h5>
                      <span class="font-semibold text-xl text-blueGray-700">{{ client['method'] }}</span>
                    </div>
                  </div>
                  <div class="w-full lg:w-6/12 px-4">
                    <div class="relative w-full pr-4 max-w-full flex-grow flex-1">
                      <h5 class="text-blueGray-400 uppercase font-bold text-xs">Query Param</h5>
                      <span class="font-semibold text-xl text-blueGray-700">{{ client['query_param'] }}</span>
                    </div>
                  </div>
                  <div class="w-full lg:w-6/12 px-4">
                    <div class="relative w-full pr-4 max-w-full flex-grow flex-1">
                      <h5 class="text-blueGray-400 uppercase font-bold text-xs">Destination</h5>
                      <span class="font-semibold text-xl text-blueGray-700">{{ client['destination'] }}</span>
                    </div>
                  </div>
                  <div class="w-full lg:w-6/12 px-4">
                    <div class="relative w-full pr-4 max-w-full flex-grow flex-1">
                      <h5 class="text-blueGray-400 uppercase font-bold text-xs">Cache Return?</h5>
                      <span class="font-semibold text-xl text-blueGray-700">{{ client['is_cache_return'] }}</span>
                    </div>
                  </div>
                  <div class="w-full lg:w-6/12 px-4">
                    <div class="relative w-full pr-4 max-w-full flex-grow flex-1">
                      <h5 class="text-blueGray-400 uppercase font-bold text-xs">Is Mock API?</h5>
                      <span class="font-semibold text-xl text-blueGray-700">{{ client['is_mock_api'] }}</span>
                    </div>
                  </div>
                  <div class="w-full lg:w-6/12 px-4">
                    <div class="relative w-full pr-4 max-w-full flex-grow flex-1">
                      <h5 class="text-blueGray-400 uppercase font-bold text-xs">Status</h5>
                      <span class="font-semibold text-xl text-blueGray-700">{{ client['status'] }}</span>
                    </div>
                  </div>
                  <div class="w-full lg:w-6/12 px-4">
                    <div class="relative w-full pr-4 max-w-full flex-grow flex-1">
                      <h5 class="text-blueGray-400 uppercase font-bold text-xs">Static Token</h5>
                      <span class="font-semibold text-xl text-blueGray-700">{{ client['static_bearer_token_forward'] }}</span>
                    </div>
                  </div>
                  <div class="w-full lg:w-6/12 px-4">
                    <div class="relative w-full pr-4 max-w-full flex-grow flex-1">
                      <h5 class="text-blueGray-400 uppercase font-bold text-xs">Description</h5>
                      <span class="font-semibold text-xl text-blueGray-700">{{ client['description'] }}</span>
                    </div>
                  </div>
                  <div class="w-full lg:w-6/12 px-4">
                    <div class="relative w-full pr-4 max-w-full flex-grow flex-1">
                      <h5 class="text-blueGray-400 uppercase font-bold text-xs">Mock Return</h5>
                      <span class="font-semibold text-xl text-blueGray-700">{{ client['mock_return'] }}</span>
                    </div>
                  </div>
                  
                </div>
              </div>          
            </div>  
            <!--footer-->
            <div class="flex items-center justify-end p-6 border-t border-solid border-blueGray-200 rounded-b">
              <button class="text-red-500 background-transparent font-bold uppercase px-6 py-2 text-sm outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150" type="button" v-on:click="toggleModal()">
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

</template>
<script>
import { UseAppStore } from '@/stores/AppStore';
import APIDataService from "@/services/APIDataService";

export default {
  setup(){
    const appStore = UseAppStore();
    // appStore.resetBreadcrumbs();
    // appStore.putBreadcrumbs("dashboard", "Dashboard", "/admin/dashboard")
    // appStore.putBreadcrumbs("client", "Client Management", "/admin/client")
    return {
      appStore
    }
  },
  created(){
    //this.getAPI()
  },
  props: {
    showModal: Boolean,
    toggleModal: {type: Function},
    itemID: String
  },
  data(){
    return {
      alertType: '',
      alertMessage: '',
      client: {}
    }
  },
  components: {
    
  },
  methods: {
    getAPI(){
      APIDataService.get(this.itemID)
        .then(response => {
          this.client = response.data["data"]["apis"][0]
          console.log(response)
        })
        .catch(e => {
          console.log(e )
        });
    }
  },

  watch: { 
      itemID: function(newVal, oldVal) { // watch it
        console.log('Prop changed: ', newVal, ' | was: ', oldVal)
        if(newVal != ''){
          this.getAPI()
        }
      }
    }

};
</script>
